import lightLogo from "@/assets/wa-light.png";
import darkLogo from "@/assets/wa-dark.png";

interface Props {
  className?: string;
  alt?: string;
}

/**
 * Renders both logos and toggles visibility via CSS based on the `dark` class
 * on <html>. This avoids any JS-driven swap or post-mount flicker.
 */
export function BrandLogo({ className, alt = "RoleBoard" }: Props) {
  return (
    <>
      <img
        src={lightLogo}
        alt={alt}
        draggable={false}
        className={`${className ?? ""} block dark:hidden`}
      />
      <img
        src={darkLogo}
        alt={alt}
        draggable={false}
        className={`${className ?? ""} hidden dark:block`}
      />
    </>
  );
}
